module.exports = __webpack_public_path__ + "images/4a809a45bed2b42ef3bb5248e65ff511.png";